<template>
    <page :tabs="tabs" :compact-mobile-view="true">
        <div class="amenities-page">
            <span class="ml-xl-3 ml-md-3 ml-lg-3 ml-1">Filter Amenities:</span>
            <amenities-multi-select
                :initialValue="initialValues"
                class="mb-2 amenities-select"
                :properties="items"
                :update="fetchAmenities"
            />
        </div>
    </page>
</template>

<script>
    import Page from '../../generic/page/page.vue';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
    import {
        CALENDAR_TAPE_CONFIG_OPTIONS_ENDPOINT,
        CALENDAR_TAPE_UPDATE_CONFIG_OPTIONS_ENDPOINT,
    } from '../../../endpoints';
    import API from '../../../api';
    import { defineAsyncComponent } from 'vue';

    const AmenitiesMultiSelect = defineAsyncComponent(() =>
        import(
            /* webpackChunkName: "lx-amenities-multi-select" */
            './amenities-multi-select.vue'
        )
    );
    export default {
        name: 'CalendarTapeConfigOptions',
        components: {
            Page,
            AmenitiesMultiSelect,
            ResponsiveButton,
        },
        data() {
            return {
                items: [],
                selectedItems: [],
                initialValues: [],
                tabs: [
                    {
                        id: 'ctConfigOptions',
                        title: 'Configuration Options',
                        active: true,
                        route: '/app/calendar-tape/options',
                    },
                    {
                        id: 'ctColorAssignments',
                        title: 'Color Assignments',
                        active: false,
                        route: '/app/calendar-tape/assignments',
                    },
                ],
            };
        },
        mounted() {
            this.fetchAmenities();
        },
        watch: {
            initialValues() {
                this.selectedItems = this.initialValues;
            },
        },
        methods: {
            async fetchAmenities() {
                try {
                    const { data } = await API.get(CALENDAR_TAPE_CONFIG_OPTIONS_ENDPOINT());
                    this.items = data.map((item) => {
                        return {
                            value: item.id,
                            text: item.name,
                        };
                    });
                    this.initialValues = data
                        .filter((item) => item.is_filtered)
                        .map((item) => ({ value: item.id, text: item.name }));
                } catch (e) {
                    this.errorToast({ text: `Could not load data.` });
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .amenities-page {
        padding: 20px;
        display: flex;
        justify-content: center;
        align-items: baseline;
        flex-direction: column;
        .amenities-select {
            width: 100%;
        }
    }
</style>
